const search3dFunctionality = () => {
  if (!document.querySelector('body').classList.contains('investment-template-default')) return;

  const areas = document.querySelectorAll('area');
  const rotateBuildingButtons = document.querySelectorAll('.rotate-building-button');
  const unavailableStatuses = ['sprzedane'];
  const mapContainers = document.querySelectorAll('.wrp-container');

  if (mapContainers && Array.from(mapContainers).length > 0) {
    mapContainers.forEach(mapContainer => {
      const rotateBuildingButton = mapContainer.querySelector('.rotate-building-button');
      const buildingId = mapContainer.dataset.buildingId;
      const buildingPosition = mapContainer.dataset.position;
      const sameBuildingMap = document.querySelector(`.wrp-container[data-building-id="${buildingId}"]:not([data-position="${buildingPosition}"])`);

      if (!sameBuildingMap && rotateBuildingButton) rotateBuildingButton.style.display = 'none';
    });

    const scrollContainer = document.querySelector('#app .ica');
    const firstActiveContainer = document.querySelector('#app .ica .wrp-container');

    if (scrollContainer) {
      scrollContainer.scrollLeft = (firstActiveContainer.offsetWidth - scrollContainer.offsetWidth) / 2;
      scrollContainer.scrollTop = (firstActiveContainer.offsetHeight - scrollContainer.offsetHeight) / 2;
    }
  }

  if (!areas || areas.length < 1) return;

  areas.forEach((area, index) => {
    const container = area.parentElement.parentElement;
    const visibleCanvas = container.querySelector('canvas[data-type="visible"]');
    const tooltip = document.querySelector('.flat-tooltip');
    const img = container.querySelector('img');
    if (visibleCanvas) {
      const visibleCanvasCtx = visibleCanvas.getContext('2d');
      let visibleCanvasPoly = area.dataset.originalCoords.split(',');

      if (img.offsetWidth) {
        visibleCanvasPoly = visibleCanvasPoly.map(n => { return n * (img.offsetWidth / img.naturalWidth); });
        area.setAttribute('coords', visibleCanvasPoly.join(','));
      }

      if (visibleCanvas.getAttribute('height') == '0' || visibleCanvas.getAttribute('width') == '0' || !visibleCanvas.getAttribute('height') || !visibleCanvas.getAttribute('width')) {
        visibleCanvas.setAttribute('height', container.offsetHeight);
        visibleCanvas.setAttribute('width', container.offsetWidth);
      }

      if (parseFloat(container.offsetHeight) > 0 && parseFloat(container.offsetWidth) > 0) {      
        if (container.classList.contains('main-view')) visibleCanvasCtx.fillStyle = 'rgba(255, 255, 255, 0.6)';
        else if (area.dataset.status == 'chosen') visibleCanvasCtx.fillStyle = 'rgba(255, 255, 0, 0.4)';      
        else if (area.dataset.status == 'similar') visibleCanvasCtx.fillStyle = 'rgba(0, 0, 255, 0.4)';
        else if (unavailableStatuses.includes(area.dataset.status)) visibleCanvasCtx.fillStyle = 'rgba(255, 0, 0, 0.4)';
        else visibleCanvasCtx.fillStyle = 'rgba(0, 255, 0, 0.4)';
        
        visibleCanvasCtx.beginPath();

        if (area.getAttribute('shape') == 'rect') {
          const rectWidth = visibleCanvasPoly[2] - visibleCanvasPoly[0];
          const rectHeight = visibleCanvasPoly[3] - visibleCanvasPoly[1];

          visibleCanvasCtx.rect(visibleCanvasPoly[0], visibleCanvasPoly[1], rectWidth, rectHeight);
        } else {
          visibleCanvasCtx.moveTo(visibleCanvasPoly[0], visibleCanvasPoly[1]);
          
          for (let item = 2; item < visibleCanvasPoly.length - 1; item += 2){
            visibleCanvasCtx.lineTo(visibleCanvasPoly[item], visibleCanvasPoly[item+1]);
          }
        }
        
        visibleCanvasCtx.closePath();
        visibleCanvasCtx.fill();
      }
    }

    area.addEventListener('mouseenter', function() {
      const canvas = container.querySelector('canvas[data-type="hover"]');
      const ctx = canvas.getContext('2d');
      let poly = this.getAttribute('coords').split(',');

      if (tooltip && !container.classList.contains('main-view')) {
        tooltip.querySelector('.flat-thumbnail img').setAttribute('src', area.dataset.infoThumbnail);
        tooltip.querySelector('.flat-name').innerText = area.dataset.infoName;
        tooltip.querySelector('.flat-area .value').innerText = area.dataset.infoArea;
        tooltip.querySelector('.flat-floor .value').innerText = area.dataset.infoFloor;
        tooltip.querySelector('.flat-status .value').innerText = area.dataset.infoStatus;

        tooltip.classList.add('active');
      }
  
      canvas.setAttribute('height', container.offsetHeight);
      canvas.setAttribute('width', container.offsetWidth);

      canvas.classList.add('active');

      ctx.clearRect(0, 0, canvas.width, canvas.height);

      if (container.classList.contains('main-view')) ctx.fillStyle = 'rgba(255, 255, 255, 0.6)';
      else if (area.dataset.status == 'chosen') ctx.fillStyle = 'rgba(255, 255, 0, 0.4)';      
      else if (unavailableStatuses.includes(area.dataset.status))  ctx.fillStyle = 'rgba(255, 0, 0, 0.4)';
      else if (area.dataset.status == 'similar') ctx.fillStyle = 'rgba(0, 0, 255, 0.4)';
      else ctx.fillStyle = 'rgba(0, 255, 0, 0.4)';

      ctx.beginPath();
      
      if (area.getAttribute('shape') == 'rect') {
        const rectWidth = poly[2] - poly[0];
        const rectHeight = poly[3] - poly[1];

        ctx.rect(poly[0], poly[1], rectWidth, rectHeight);
      } else {
        ctx.moveTo(poly[0], poly[1]);

        for (let item = 2; item < poly.length - 1; item += 2){
          ctx.lineTo(poly[item], poly[item+1]);
        }
      }
      
      ctx.closePath();
      ctx.fill();
    });

    area.addEventListener('mouseleave', function() {
      const canvas = container.querySelector('canvas');

      if (tooltip && !container.classList.contains('main-view') && window.innerWidth > 992) tooltip.classList.remove('active');
      else if (tooltip && !container.classList.contains('main-view')) setTimeout(() => { tooltip.classList.remove('active'); }, 1);

      canvas.classList.remove('active');
    });

    area.addEventListener('click', function(e) {
      const areaLink = area.getAttribute('href');

      if (window.innerWidth > 992 || container.classList.contains('main-view')) window.location.href = areaLink;
      else {
        e.preventDefault();

        setTimeout(() => {
          tooltip.querySelector('.flat-thumbnail img').setAttribute('src', area.dataset.infoThumbnail);
          tooltip.querySelector('.flat-name').innerText = area.dataset.infoName;
          tooltip.querySelector('.flat-area .value').innerText = area.dataset.infoArea;
          tooltip.querySelector('.flat-floor .value').innerText = area.dataset.infoFloor;
          tooltip.querySelector('.flat-status .value').innerText = area.dataset.infoStatus;
          tooltip.querySelector('.flat-link').setAttribute('href', area.getAttribute('href'));
          tooltip.classList.add('active');
        }, 1);
      }
    });

    area.addEventListener('mousemove', function(e) {
      if (!tooltip || container.classList.contains('main-view') || window.innerWidth <= 992) return;

      tooltip.style.cssText = `top: ${e.clientY - tooltip.offsetHeight - 20}px; left: ${e.clientX - tooltip.offsetWidth / 2}px;`;
    });
  });

  const mobileButton = document.querySelector('.rotate-building-button-mobile');

  if (mobileButton) {
    mobileButton.addEventListener('click', function() {
      const currentlyActiveContainerButton = $('.wrp-container.active .rotate-building-button');

      if (!currentlyActiveContainerButton || currentlyActiveContainerButton.length < 1) return;

      currentlyActiveContainerButton.trigger('click');
    });
  }

  if (rotateBuildingButtons && rotateBuildingButtons.length > 0) {
    rotateBuildingButtons.forEach(rotateBuildingButton => {
      rotateBuildingButton.addEventListener('click', function() {
        const currentlyActiveContainer = rotateBuildingButton.parentElement;
        
        if (!currentlyActiveContainer || !currentlyActiveContainer.classList.contains('active')) return;

        const scrollContainer = document.querySelector('#app .ica');
        const allContainers = document.querySelectorAll('.wrp-container');

        if (allContainers && Array.from(allContainers).length > 0) {
          allContainers.forEach(container => {
            const appContainer = container.closest('#app');
            const initialHeight = container.offsetHeight;
            const initialWidth = container.offsetWidth;

            if (appContainer.offsetHeight >= appContainer.offsetWidth) {
              zoomValue = -(1 - appContainer.offsetWidth / initialWidth);
            } else {
              zoomValue = -(1 - appContainer.offsetHeight / initialHeight);
            }

            container.style.transform = `scale(${1 + zoomValue})`;
            container.setAttribute('data-previous-zoom', zoomValue);
            container.setAttribute('data-last-transform', '0,0');
            scrollContainer.setAttribute('data-current-scale', 1 + zoomValue);
            scrollContainer.setAttribute('data-initial-height', initialHeight);
            scrollContainer.setAttribute('data-initial-width', initialWidth);
          });
        }
        
        const currentPosition = currentlyActiveContainer.dataset.position;
        const currentBuilding = currentlyActiveContainer.dataset.buildingId;
        
        let nextContainer = document.querySelector(`.wrp-container[data-position="${parseInt(currentPosition) + 1}"][data-building-id="${currentBuilding}"]`);
        
        if (!nextContainer) nextContainer = document.querySelector(`.wrp-container[data-position="0"][data-building-id="${currentBuilding}"]`)
        if (!nextContainer) nextContainer = document.querySelector(`.wrp-container[data-position="1"][data-building-id="${currentBuilding}"]`);
        if (!nextContainer) return;

        const img = nextContainer.querySelector('img');

        currentlyActiveContainer.classList.remove('active');
        nextContainer.classList.add('active');

        if (parseInt(nextContainer.querySelector('canvas[data-type="visible"]').getAttribute('height')) <= 0 || parseInt(nextContainer.querySelector('canvas[data-type="visible"]').getAttribute('width')) <= 0) {
          nextContainer.querySelectorAll('area').forEach(area => {
            const visibleCanvas = nextContainer.querySelector('canvas[data-type="visible"]');
            const visibleCanvasCtx = visibleCanvas.getContext('2d');
            let visibleCanvasPoly = area.dataset.originalCoords.split(',');

            if (visibleCanvas.getAttribute('height') == '0' || visibleCanvas.getAttribute('width') == '0' || !visibleCanvas.getAttribute('height') || !visibleCanvas.getAttribute('width')) {
              visibleCanvas.setAttribute('height', nextContainer.offsetHeight);
              visibleCanvas.setAttribute('width', nextContainer.offsetWidth);
            }
            
            if (img.offsetWidth) {
              visibleCanvasPoly = visibleCanvasPoly.map(n => { return n * (img.offsetWidth / img.naturalWidth); });
              area.setAttribute('coords', visibleCanvasPoly.join(','));
            }
            
            if (area.dataset.status == 'chosen') visibleCanvasCtx.fillStyle = 'rgba(255, 255, 0, 0.4)';      
            else if (area.dataset.status == 'similar') visibleCanvasCtx.fillStyle = 'rgba(0, 0, 255, 0.4)';
            else if (unavailableStatuses.includes(area.dataset.status)) visibleCanvasCtx.fillStyle = 'rgba(255, 0, 0, 0.4)';
            else visibleCanvasCtx.fillStyle = 'rgba(0, 255, 0, 0.4)';

            visibleCanvasCtx.beginPath();

            if (area.getAttribute('shape') == 'rect') {
              const rectWidth = visibleCanvasPoly[2] - visibleCanvasPoly[0];
              const rectHeight = visibleCanvasPoly[3] - visibleCanvasPoly[1];
              
              visibleCanvasCtx.rect(visibleCanvasPoly[0], visibleCanvasPoly[1], rectWidth, rectHeight);
            } else {
              visibleCanvasCtx.moveTo(visibleCanvasPoly[0], visibleCanvasPoly[1]);
              
              for (let item = 2; item < visibleCanvasPoly.length - 1; item += 2){
                visibleCanvasCtx.lineTo(visibleCanvasPoly[item], visibleCanvasPoly[item+1]);
              }
            }
            
            visibleCanvasCtx.closePath();
            visibleCanvasCtx.fill();
          });
        }
      });
    });
  }
}

$(document).ready(setTimeout(search3dFunctionality, 1000));

const mobileSearch3dZooming = () => {
  const zoomButtons = document.querySelectorAll('.zoom-buttons .zoom-button');

  if (!zoomButtons || Array.from(zoomButtons).length < 1) return;

  const scrollContainer = document.querySelector('#app .ica');

  const allContainers = document.querySelectorAll('.wrp-container');

  if (allContainers && Array.from(allContainers).length > 0) {
    allContainers.forEach(container => {
      const appContainer = container.closest('#app');
      const initialHeight = container.offsetHeight;
      const initialWidth = container.offsetWidth;

      if (appContainer.offsetHeight >= appContainer.offsetWidth) {
        zoomValue = -(1 - appContainer.offsetWidth / initialWidth);
      } else {
        zoomValue = -(1 - appContainer.offsetHeight / initialHeight);
      }

      container.style.transform = `scale(${1 + zoomValue})`;
      container.setAttribute('data-previous-zoom', zoomValue);
      container.setAttribute('data-last-transform', '0,0');
      scrollContainer.setAttribute('data-current-scale', 1 + zoomValue);
      scrollContainer.setAttribute('data-initial-height', initialHeight);
      scrollContainer.setAttribute('data-initial-width', initialWidth);
    });
  }

  zoomButtons.forEach(zoomButton => {
    zoomButton.addEventListener('click', function() {
      const currentlyActiveContainer = document.querySelector('.wrp-container.active');
      const pinchTargetPreviousZoom = currentlyActiveContainer.dataset.previousZoom ? parseFloat(currentlyActiveContainer.dataset.previousZoom) : 0;
      const isZoomingIn = zoomButton.classList.contains('zoom-button--in') ? .15 : -.15;
      const appContainer = currentlyActiveContainer.closest('#app');
      const initialHeight = currentlyActiveContainer.offsetHeight;
      const initialWidth = currentlyActiveContainer.offsetWidth;
      let zoomValue = pinchTargetPreviousZoom + isZoomingIn;

      if (appContainer.offsetHeight >= appContainer.offsetWidth && initialWidth * (1 + zoomValue) <= appContainer.offsetWidth) {
        zoomValue = -(1 - appContainer.offsetWidth / initialWidth);
      } else if (appContainer.offsetHeight < appContainer.offsetWidth && initialHeight * (1 + zoomValue) <= appContainer.offsetHeight) {
        zoomValue = -(1 - appContainer.offsetHeight / initialHeight);
      }
      
      currentlyActiveContainer.style.transform = `scale(${1 + zoomValue})`;
      currentlyActiveContainer.setAttribute('data-previous-zoom', zoomValue);
      currentlyActiveContainer.setAttribute('data-last-transform', '0,0');
      scrollContainer.setAttribute('data-current-scale', 1 + zoomValue);
      scrollContainer.setAttribute('data-initial-height', initialHeight);
      scrollContainer.setAttribute('data-initial-width', initialWidth);
    });
  });

  let initialTouch = {};

  document.addEventListener('touchstart', function(e) {
    if (e.target.closest('#app')) document.body.style.overflowY = 'hidden';
    else document.body.style.overflowY = 'scroll';

    const scrollContainerTop = scrollContainer.getBoundingClientRect().top;
    const scrollContainerLeft = scrollContainer.getBoundingClientRect().left;

    initialTouch.x = e.touches[0].clientX - scrollContainerLeft;
    initialTouch.y = e.touches[0].clientY - scrollContainerTop;
  });

  document.addEventListener('touchend', function() {
    const currentlyActiveContainer = document.querySelector('.wrp-container.active');

    currentlyActiveContainer.setAttribute('data-last-transform', currentlyActiveContainer.dataset.currentTransform);
  });

  let dist = 0;
  let previousDist = 0;
  let zooming = false;

  scrollContainer.addEventListener('touchmove', function(e) {
    if (e.touches.length > 1) {
      zooming = true;
      const currentlyActiveContainer = document.querySelector('.wrp-container.active');
      const pinchTargetPreviousZoom = currentlyActiveContainer.dataset.previousZoom ? parseFloat(currentlyActiveContainer.dataset.previousZoom) : 0;
      const appContainer = currentlyActiveContainer.closest('#app');
      const initialHeight = currentlyActiveContainer.offsetHeight;
      const initialWidth = currentlyActiveContainer.offsetWidth;

      const x = e.touches[0].clientX - e.touches[1].clientX;
      const y = e.touches[0].clientY - e.touches[1].clientY;
      dist = Math.sqrt(x*x + y*y);

      if (Math.abs(dist - previousDist) > 25 || (dist == 0 && previousDist == 0)) {
        currentlyActiveContainer.classList.add('zooming');
        let zoomValue = pinchTargetPreviousZoom + (dist > previousDist ? .05 : -.05);

        if (appContainer.offsetHeight >= appContainer.offsetWidth && initialWidth * (1 + zoomValue) <= appContainer.offsetWidth) {
          zoomValue = -(1 - appContainer.offsetWidth / initialWidth);
        } else if (appContainer.offsetHeight < appContainer.offsetWidth && initialHeight * (1 + zoomValue) <= appContainer.offsetHeight) {
          zoomValue = -(1 - appContainer.offsetHeight / initialHeight);
        }
        
        currentlyActiveContainer.style.transform = `scale(${1 + zoomValue})`;
        currentlyActiveContainer.setAttribute('data-previous-zoom', zoomValue);
        currentlyActiveContainer.setAttribute('data-last-transform', '0,0');
        scrollContainer.setAttribute('data-current-scale', 1 + zoomValue);
        scrollContainer.setAttribute('data-initial-height', initialHeight);
        scrollContainer.setAttribute('data-initial-width', initialWidth);

        // document.querySelector('.test').innerHTML = `<div>scale: ${1 + zoomValue}</div>`;
        // document.querySelector('.test').innerHTML += `<div>previousZoom: ${zoomValue}</div>`;
        // document.querySelector('.test').innerHTML += `<div>dist: ${dist}</div>`;

        previousDist = dist;
      }
    } else if (!zooming) {
      const currentlyActiveContainer = document.querySelector('.wrp-container.active');
      currentlyActiveContainer.classList.remove('zooming');
      const currentScale = scrollContainer.dataset.currentScale ? scrollContainer.dataset.currentScale : 1;
      const initialWidth = scrollContainer.dataset.initialWidth ? parseInt(scrollContainer.dataset.initialWidth) : currentlyActiveContainer.offsetWidth;
      const initialHeight = scrollContainer.dataset.initialHeight ? parseInt(scrollContainer.dataset.initialHeight) : currentlyActiveContainer.offsetHeight;
      const scrollContainerTop = scrollContainer.getBoundingClientRect().top;
      const scrollContainerLeft = scrollContainer.getBoundingClientRect().left;
      const touchX = e.touches[0].clientX - scrollContainerLeft;
      const touchY = e.touches[0].clientY - scrollContainerTop;
      const currentlyActiveContainerTransform = currentlyActiveContainer.hasAttribute('data-last-transform') ? currentlyActiveContainer.getAttribute('data-last-transform').split(',') : [0, 0];
  
      if (!currentScale || !initialHeight || !initialWidth) return;

      const containerWidth = parseInt(scrollContainer.offsetWidth);
      const containerHeight = parseInt(scrollContainer.offsetHeight);

      if (containerWidth == initialWidth * currentScale || containerHeight == initialHeight * currentScale) return;

      const maxScrollX = ((initialWidth * currentScale) - containerWidth) / 2 / currentScale;
      const maxScrollY = ((initialHeight * currentScale) - containerHeight) / 2 / currentScale;
      const minScrollX = -maxScrollX;
      const minScrollY = -maxScrollY;
      let scrollX = touchX - initialTouch.x + parseInt(currentlyActiveContainerTransform[0]);
      let scrollY = touchY - initialTouch.y + parseInt(currentlyActiveContainerTransform[1]);

      if (isNaN(scrollX)) scrollX = touchX - initialTouch.x;
      else if (scrollX >= maxScrollX) scrollX = maxScrollX;
      else if (scrollX <= minScrollX) scrollX = minScrollX;
    
      if (isNaN(scrollY)) {
        scrollY = touchY - initialTouch.y;
      } else if (scrollY >= maxScrollY) {
        scrollY = maxScrollY;
        document.body.style.overflowY = 'scroll';
      } else if (scrollY <= minScrollY) {
        scrollY = minScrollY;
        document.body.style.overflowY = 'scroll';
      } else {
        document.body.style.overflowY = 'hidden';
      }
      
      currentlyActiveContainer.style.transform = `scale(${currentScale}) translate(${scrollX}px, ${scrollY}px)`;
      currentlyActiveContainer.setAttribute('data-current-transform', `${scrollX},${scrollY}`);
    }
  });

  scrollContainer.addEventListener('touchend', function() {
    setTimeout(() => {
      zooming = false;
      dist = 0;
      previousDist = 0;
    }, 300);
  });
}

$(document).ready(setTimeout(mobileSearch3dZooming, 1001));